// -------------------------------------------
// JavaScript ScrollTo
// Author: Globalia
// Licensed under the WTFPL license
// -------------------------------------------

( function( global ) { // eslint-disable-line

    var pluginName = 'grScrollTo';

    //  Constructor
    // --------------------------------------------------------------------------

    function grScrollTo(selector) {

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Set default parameters
        this.target = '';
        this.extraHeight = 0;

        // Retrieve plugin custom parameters
        this.param = this.selector.getAttribute('gr-scroll-to').split(' ');

        // Overwrite with custom parameters
        for (var i = 0, len = this.param.length; i < len; i++) {
            var attr = this.param[i];

            if (!isNaN(attr)) this.extraHeight = parseInt(attr, 10);
            if (attr.charAt(0) === '#' || attr.charAt(0) === '.') this.target = attr;
        }

        // Get target element
        this.targetEl = document.querySelector(this.target);

        // Init grPlugin
        this.init();
    }

    //  Methods
    // --------------------------------------------------------------------------

    grScrollTo.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            // Bind all event handlers for referencability
            this['mouseclickHandler'] = this['mouseclickHandler'].bind(this);
            this.selector.addEventListener('click', this.mouseclickHandler);

            // Flag the plugin as ready
            this.ready = true;
            global.methods.toggleAttributeValue(this.selector, 'gr-scroll-to', 'ready');
            if (global.verbose) console.log(pluginName + '(' + this.selector.id + '): ready');
        }
    }

    grScrollTo.prototype.mouseclickHandler = function mouseclickHandler(event) {
        event.preventDefault();

        var start = window.pageYOffset;
        var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

        var nav = document.querySelector('[gr-nav]');
        var extraHeight = this.extraHeight;

        if (global.methods.hasAttributeValue(nav, 'gr-nav', 'sticky')) {
            extraHeight += nav.offsetHeight;
        }

        var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
        var destinationOffset = this.targetEl.offsetTop - extraHeight;
        var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

        this.animate(start, startTime, destinationOffsetToScroll);
    }

    grScrollTo.prototype.animate = function animate(start, startTime, destinationOffsetToScroll) {
        global.methods.toggleAttributeValue(this.selector, 'gr-scroll-to', 'processing');

        if ('requestAnimationFrame' in window === false) {
            window.scroll(0, destinationOffsetToScroll);
            return;
        }

        function scroll() {
            var now = 'now' in window.performance ? performance.now() : new Date().getTime();
            var time = Math.min(1, ((now - startTime) / 600));
            var timeFunction = global.methods.easeOutCubic(time);
            window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

            if (window.pageYOffset === destinationOffsetToScroll) return;

            requestAnimationFrame(scroll);
        }

        scroll();

        global.methods.removeAttributeValue(this.selector, 'gr-scroll-to', 'processing');
        global.methods.toggleAttributeValue(this.selector, 'gr-scroll-to', 'done');
        if (global.verbose) console.log(pluginName + ': done');
    }

    // Destroy - remove listeners to prevent from memory leak
    grScrollTo.prototype.destroy = function destroy() {
        global.methods.removeAttributeValue(this.selector, 'gr-scroll-to', 'ready processing done');
        if (global.verbose) console.log(pluginName + ': destroyed');
    };

    //  Auto-Instantiation
    // --------------------------------------------------------------------------

    var all = {}, index;
    if (document.querySelectorAll('[gr-scroll-to]').length) {
        window.groots.grScrollTo = { instances: {} };
        all = document.querySelectorAll('[gr-scroll-to]');
        index = -1;
        while (all[++index])
            global.grScrollTo.instances[index] = new grScrollTo(all[index]);
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grScrollTo;
    // Export to Browser
    else global[pluginName] = grScrollTo; // eslint-disable-line

}( window.groots ));
